import * as React from 'react';
import TextField from '@mui/material/TextField';
import { Autocomplete, ListItem } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useSimpleGetAllOrders } from '../../scenes/PersonFroms/FunctionDesignersReport/Hooks/index';
import { useEffect } from 'react'

export default function InfiniteScrollAutocomplete({ designerId = '', setFieldValue = () => { }, order = {}, mode = 'add', setMainOrderSelected = () => { }, resetAct = false }) {
  const listboxRef = React.useRef(null);
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [hasMore, setHasMore] = React.useState(true);
  const [orderSelected, setOrderSelected] = React.useState({});
  const [queryBody, setQueryBody] = React.useState({
    page: 1,
    pageSize: 20,
    searchTerm: "",
    designerId: ''
  });

  // React.useEffect(() => {
  //   setQueryBody((prev) => ({ ...prev, 'designerId': designerId, 'searchTerm': '' }))
  // }, [designerId])




  const { data: fetchedData, isLoading: getOrdersLoading } = useSimpleGetAllOrders(queryBody);

  React.useEffect(() => {
    if (fetchedData) {
      // توجه: اگر fetchedData یک آبجکت است و آرایه داخل خاصیتی (مثل data) قرار دارد، اینجا را اصلاح کنید
      const newItems = Array.isArray(fetchedData) ? fetchedData : [];

      if (queryBody.page === 1) {
        setOptions(newItems);
      } else {
        setOptions(prev => [...prev, ...newItems]);
      }

      if (newItems.length < queryBody.pageSize) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
    }
  }, [fetchedData, queryBody.page]);

  const handleScroll = (event) => {
    const listboxNode = listboxRef.current;
    if (!listboxNode || !hasMore || getOrdersLoading) return;
    const { scrollTop, scrollHeight, clientHeight } = listboxNode;
    if (scrollHeight - scrollTop <= clientHeight + 20) {
      setQueryBody(prev => ({ ...prev, page: prev.page + 1 }));
    }
  };

  const handleInputChange = (event, newInputValue, reason) => {
    if (reason === 'input') {
      setQueryBody(prev => ({
        ...prev,
        page: 1,
        searchTerm: newInputValue
      }));
      setHasMore(true);
    }
  };


  React.useEffect(() => {

    if (mode === 'edit' && order) {
      // setQueryBody((prev) => ({ ...prev, 'searchTerm': order?.orderName }));
      let seleted = fetchedData?.find(item => item.id === order.orderId);
      setOrderSelected(seleted);
    }
  }, [order, fetchedData]);



  React.useEffect(() => {

    if (resetAct) {
      setOrderSelected({})
    }

  }, [resetAct]);


 React.useEffect(() => {
      if (designerId) {
        setQueryBody((prev)=>({...prev,'designerId':designerId,'searchTerm':''}))
      }
      
  }, [designerId]);
  


  
























  return (
    <Autocomplete
      fullWidth
      sx={{
        color: "#1E6AFD",
        backgroundColor: "#1E6AFD1A",
        fontSize: "0.7rem"

      }}
      // open={open}
      // onOpen={() => setOpen(true)}
      // onClose={() => setOpen(false)}
      options={options}


      onChange={(event, value, reason) => {
        if (reason === "clear" || value === null) {
          setQueryBody(prev => ({ ...prev, searchTerm: "" }));
          setOrderSelected(null);
          setMainOrderSelected(null)
        }

        else {
          setQueryBody(prev => ({ ...prev, searchTerm: "" }));
          setOrderSelected({});
          setOrderSelected(value)
          setFieldValue('orderId', value?.id);
        }
      }}


      value={orderSelected}
      // --- تنظیمات مهم بر اساس ساختار داده شما ---
      getOptionLabel={(option) => option?.orderName || ""}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      // ----------------------------------------------

      loading={getOrdersLoading}
      filterOptions={(x) => x}
      onInputChange={handleInputChange}


      ListboxProps={{
        ref: listboxRef,
        onScroll: handleScroll,
        sx: { maxHeight: 300 }
      }}

      renderInput={(params) => (
        <TextField
          sx={{
            backgroundColor: "#1E6AFD1A", // رنگ پس‌زمینه
            "& .MuiInputBase-root": {
              // color: "#1E6AFD", // رنگ متن تایپ شده
              fontSize: "0.9rem", // سایز فونت
              height: 40, // ارتفاع فیلد (اختیاری)
              padding: "0 5px" // پدینگ داخلی (اختیاری)
            },


          }}
          {...params}
          size="small"
          label="جست و جوی سفارش"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {getOrdersLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}

      renderOption={(props, option) => (
        <ListItem {...props} key={option.id} sx={{ fontSize: "0.75rem" }}>
          {option.orderNumber + '-' + option.orderName}
        </ListItem>
      )}
    />
  );
}